// Datos ficticios de ejemplo — plantilla "Alba" (bautismo).
// Usa el contrato `protagonista` (el/la bebé). Ilustraciones SVG originales:
// paloma con rama de olivo y arco bautismal. Sin imágenes con derechos.

export const datosEjemplo = {
  tipoEvento: "bautismo",
  plantillaId: "bautismo-alba",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "Falta poquito", titulo: "Contando los días", textoFinalizado: "¡Llegó el gran día!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Dónde y cuándo", titulo: "Ceremonia y celebración" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Guardá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Ternura", titulo: "Momentos de Emma" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El plan", titulo: "Una mañana especial" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Padrinos", titulo: "Quienes la acompañan" },
    { id: "video", visible: false, orden: 7, etiqueta: "Video", titulo: "Mirá el video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "Para escuchar", titulo: "Canciones de este día" },
    { id: "regalos", visible: true, orden: 9, etiqueta: "Mesa de regalos", titulo: "Si querés tener un detalle" },
    { id: "rsvp", visible: true, orden: 10, etiqueta: "Confirmación", titulo: "Acompañanos" },
    { id: "enlaces", visible: true, orden: 11, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 12, etiqueta: "Participá", titulo: "Dejale tus palabras" },
    { id: "cierre", visible: true, orden: 13 },
  ],

  protagonista: {
    nombre: "Emma",
    fraseIntroductoria: "Mi Bautismo",
    mensajePortada:
      "Con la alegría de verme crecer, mis papás te invitan a celebrar mi bautismo.",
    mensajeCierre:
      "Gracias por acompañarnos en un día tan importante para nuestra familia.",
    textoBotonEntrada: "Ver la invitación",
  },

  evento: {
    fechaISO: "2027-03-21T11:00:00-03:00",
    fechaLegible: "Domingo 21 de marzo de 2027",
    fechaCorta: "21 · 03 · 2027",
    ciudad: "Asunción, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1543342384-1f1350e27861?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1522771930-78848d9293e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Emma con su traje de osito",
      },
      {
        src: "https://images.unsplash.com/photo-1473177104440-ffee2f376098?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Interior luminoso de la iglesia",
      },
      {
        src: "https://images.unsplash.com/photo-1438032005730-c779502df39b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Vitrales de la parroquia",
      },
      {
        src: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Mesa preparada para la celebración",
      },
    ],
  },

  eventos: [
    {
      id: "ceremonia",
      etiqueta: "Ceremonia religiosa",
      lugar: "Parroquia San Roque",
      direccion: "Av. Eusebio Ayala km 4, Asunción",
      horario: "11:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Parroquia+San+Roque+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
    {
      id: "celebracion",
      etiqueta: "Almuerzo y brindis",
      lugar: "Salón Jardín del Sol",
      direccion: "Capitán Figari 1234, Asunción",
      horario: "13:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Capit%C3%A1n+Figari+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Bautismo de Emma",
    descripcion: "Ceremonia 11:00 h en Parroquia San Roque y almuerzo 13:00 h en Salón Jardín del Sol.",
    texto: "Domingo 21 de marzo de 2027 · Asunción, Paraguay. Guardá la fecha.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-03-21T11:00:00-03:00",
    finISO: "2027-03-21T16:00:00-03:00",
    ubicacion: "Parroquia San Roque, Asunción, Paraguay",
  },

  itinerario: [
    { hora: "10:30", titulo: "Llegada a la parroquia", descripcion: "Recibimos a la familia y amigos.", icono: "iglesia" },
    { hora: "11:00", titulo: "Ceremonia", descripcion: "Celebración del sacramento.", icono: "vela" },
    { hora: "12:00", titulo: "Fotos", descripcion: "Retratos con los padrinos y la familia.", icono: "camara" },
    { hora: "13:00", titulo: "Almuerzo", descripcion: "Brindis y almuerzo en el salón.", icono: "cena" },
    { hora: "15:30", titulo: "Cierre", descripcion: "Sorpresa dulce y agradecimientos.", icono: "brillo" },
  ],

  menciones: [
    {
      nombre: "Carolina Duarte",
      rol: "Madrina",
      foto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Andrés Vera",
      rol: "Padrino",
      foto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DX4sWSpwq3LiO",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  regalos: {
    mensaje: "Tu presencia es el mejor regalo. Si además querés tener un detalle con Emma, acá te dejamos opciones.",
    tiendas: [
      {
        nombre: "Baby Shop Asunción",
        url: "https://www.google.com/maps/search/?api=1&query=baby+shop+Asunci%C3%B3n",
        nota: "Mesa de regalos · Emma Ramos",
      },
      {
        nombre: "Juguetería El Duende",
        url: "https://www.google.com/maps/search/?api=1&query=jugueter%C3%ADa+Asunci%C3%B3n",
        nota: "Lista nº 2027-EMMA",
      },
    ],
    alternativa: {
      titulo: "Lluvia de sobres",
      texto: "si preferís, habrá un buzón en el salón.",
    },
  },

  rsvp: {
    mensaje:
      "Nos encantaría contar con tu presencia en este día tan especial para nuestra familia.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 7 de marzo de 2027",
  },

  enlaces: [
    { texto: "Sugerencia de regalos", url: "https://www.pinterest.com" },
    { texto: "#BautismoDeEmma", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de deseos",
      texto: "Dejale a Emma tus palabras para cuando crezca.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Compartí tus fotos del bautismo.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
